import React from 'react';
import { createContext } from 'react';
import { okResult } from 'libs/end-to-end/src/result';
import { CustomVizHook } from 'apps/sigma2-ui/src/components/custom-viz/hooks/custom-viz-hook';

export const CustomVizContext = createContext<CustomVizHook>({
  doViz: () => {},
  result: okResult(null),
  resultCreatedAt: null,
  staleResult: okResult(null),
  staleResultCreatedAt: null,
  dropdownOptions: [],
  status: 'initialization',
  lastSuccessfulCustomVizRequest: null,
  cancelViz: () => {},
  currentInProgressCustomVizRequest: null,
  hasCurrentCustomVizPolledMultipleTimes: false,
});
